function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../locales/keys';
var ReturnDeviceModalComponent = /*#__PURE__*/function () {
  function ReturnDeviceModalComponent($filter, $ngRedux) {
    _classCallCheck(this, ReturnDeviceModalComponent);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      AMOUNT_TYPE: {
        MAX: 'max',
        CUSTOM: 'custom'
      },
      creditLocaleKeys: CustomerCareKeys.ORDER_DETAILS.CREDIT,
      CustomerCareKeys: CustomerCareKeys,
      extraErrors: [],
      MAXIMUM_DESCRIPTION_LENGTH: 100,
      model: {
        ReasonCode: null,
        Description: null
      }
    });
  }
  return _createClass(ReturnDeviceModalComponent, [{
    key: "$onInit",
    value: function $onInit() {
      this.maximumRefundableAmount = this.returnDetails[0].MaximumRefundableAmount || 0;
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      if (this.ReturnDeviceForm.$valid) {
        var _this$model = this.model,
          Description = _this$model.Description,
          ReasonCode = _this$model.ReasonCode;
        var deviceRefundDetails = Object.assign({
          Description: Description,
          ReasonCode: ReasonCode,
          SubscriberDeviceRefundDetails: [{
            InventoryTypeId: this.inventoryTypeId,
            RefundAmount: this.maximumRefundableAmount,
            SubscriberProductId: this.subscriberProductId
          }]
        });
        this.onSubmit()(deviceRefundDetails);
      }
    }
  }]);
}();
export default {
  bindings: {
    creditReasons: '<',
    currencyCode: '<',
    isFetchingDeviceReturnDetails: '<',
    inventoryTypeId: '<',
    onClose: '&',
    onSubmit: '&',
    returnDetails: '<',
    returnDeviceTitle: '@',
    subscriberProductId: '<'
  },
  template: require('./return.device.modal.html'),
  controller: ReturnDeviceModalComponent,
  controllerAs: 'ReturnDevice'
};